import { render, staticRenderFns } from "./AccountFormSource.vue?vue&type=template&id=4deb760e&scoped=true&"
import script from "./AccountFormSource.vue?vue&type=script&lang=ts&"
export * from "./AccountFormSource.vue?vue&type=script&lang=ts&"
import style0 from "./AccountFormSource.vue?vue&type=style&index=0&id=4deb760e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4deb760e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
